import React, { useEffect, useMemo } from "react";
import { useAppSelector } from "../../../Store";
import { Graph_QL, useAnimal } from "../../../Services";
import { ValueType } from "../../../Definitions";

export const useAnimalOptions = () => {
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getAnimalInfo, data: animalsState } = useAnimal(connection)

  useEffect(() => {
    getAnimalInfo({fetchAmount: 500})
  }, []);

  const animalOptions: ValueType[] = useMemo(() => {
    if (animalsState && animalsState[domain]) {
      return animalsState[domain].data
        .filter(a => a.deleted !== true)
        .map(animal => ({
        label: animal.animal_number.toString(),
        id: animal.animal_id
      }))
    }
    return []
  },[animalsState, domain])

  return animalOptions;
};
